var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileSplash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 315,
    viewBox: "0 0 393 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 148.316L196.5 0V165.632L0 313.948V148.316Z",
    fill: "#F8D24A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.5 149.071L393 0.755405V166.388L196.5 314.704V149.071Z",
    fill: "#F8D24A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSplash);
export default __webpack_public_path__ + "static/media/mobile-splash.6a0feea6cf956bef4313fc1ba95c0ba2.svg";
export { ForwardRef as ReactComponent };